import { first } from 'rxjs/operators';
import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnChanges
} from '@angular/core'
import { ModalService } from '../../services/modal/modal.service'
import { PaginationModalComponent } from '../pagination-modal/pagination-modal.component'

@Component({
  selector: 'pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.less']
})
export class PaginationComponent implements OnInit, OnChanges {
  @Input() pages: any;
  @Input() initialPage: number = 0;
  @Input() maxPageNumber = 11;
  @Input() resetPageNumOnChange: boolean = false
  @Output() currentPageNumChange = new EventEmitter<number>();
  currentPageNum: number;
  pageArray: number[] = [];
  private _firstLoad: boolean = true;

  constructor(private modalService: ModalService) {

  }

  ngOnInit() {
    this.currentPageNum = this.initialPage;
    if (Array.isArray(this.pages)) {
      this.updatePagination();
    }
  }

  ngOnChanges() {
    if (Array.isArray(this.pages)) {
      if (this.resetPageNumOnChange && !this._firstLoad) {
        this.currentPageNum = 0;
      }
      this.updatePagination();
      this._firstLoad = false;
    }
  }

  updatePagination() {
    // Max number of pages showing (Not including current)
    const maxPageNum = this.maxPageNumber;
    const tempPageArray = [this.currentPageNum];
    let lowerPaginationLimit = this.currentPageNum;
    let upperPaginationLimit = this.currentPageNum;
    for (let index = 0; index < maxPageNum; index++) {
      if (lowerPaginationLimit > 0) {
        lowerPaginationLimit--;
        tempPageArray.unshift(lowerPaginationLimit);
      }
      if (tempPageArray.length === maxPageNum) {
        break;
      }
      if (upperPaginationLimit < this.pages.length - 1) {
        upperPaginationLimit++;
        tempPageArray.push(upperPaginationLimit);
      }
      if (tempPageArray.length === maxPageNum) {
        break;
      }
    }
    if (tempPageArray[0] !== 0) {
      tempPageArray[0] = 0;
      tempPageArray[1] = -1;
    }
    const last = tempPageArray.length - 1;
    if (tempPageArray[last] !== this.pages.length - 1) {
      tempPageArray[last] = this.pages.length - 1;
      tempPageArray[last - 1] = -1;
    }

    this.pageArray = tempPageArray;
  }

  nextPage() {
    let num = this.currentPageNum + 1;
    if (num >= this.pages.length) {
      num = 0;
    }
    this.setPage(num);
  }

  previousPage() {
    let num = this.currentPageNum - 1;
    if (num < 0) {
      num = this.pages.length - 1;
    }
    this.setPage(num);
  }

  setPage(page: number) {
    if (page !== -1) {
      this.currentPageNum = page;
      this.currentPageNumChange.emit(page);
      if (Array.isArray(this.pages)) {
        this.updatePagination();
      }
    } else {
      this.openModal();
    }
  }

  openModal() {
    this.modalService.open(PaginationModalComponent, {
      closable: false,
      inputs: {
        min: 1,
        max: this.pages.length,
        current: this.currentPageNum + 1,
      },
      outputs: ['pageChange'],
    })
    this.modalService.onOpened.pipe(first()).subscribe(obj => {
      const outputs = obj['outputs']
      if (outputs['pageChange']) {
        outputs['pageChange'].pipe(first()).subscribe(newPage => {
          this.setPage(newPage - 1);
        })
      }
    })
  }
}
